import { useId, useLayoutEffect, useRef, type ReactNode } from "react";
import { navigateTabs } from "../lib/tabNavigation";

export type DeskView = "attention" | "map" | "news";
interface Props {
  view: DeskView;
  onChange: (view: DeskView) => void;
  attention: ReactNode;
  map: ReactNode;
  news: ReactNode;
}
const TASKS: { id: DeskView; label: string }[] = [
  { id: "attention", label: "Attention" },
  { id: "map", label: "Map" },
  { id: "news", label: "News" },
];

/** Direct task access, one visible scroller, and no lost work on a tab change. */
export function OperatorRail({ view, onChange, attention, map, news }: Props) {
  const id = useId();
  const body = useRef<HTMLDivElement>(null);
  const positions = useRef<Record<DeskView, number>>({ attention: 0, map: 0, news: 0 });
  useLayoutEffect(() => {
    if (body.current) body.current.scrollTop = positions.current[view];
  }, [view]);
  const content = { attention, map, news };
  return <aside className="right-bar operator-rail" aria-label="Operations desk">
    <div className="operator-rail-tabs" role="tablist" tabIndex={-1} aria-label="Operations tasks" onKeyDown={navigateTabs}>
      {TASKS.map(task => <button key={task.id} type="button" role="tab"
        id={`${id}-${task.id}-tab`} data-desk-tab={task.id}
        aria-controls={`${id}-${task.id}-panel`} aria-selected={view === task.id}
        tabIndex={view === task.id ? 0 : -1} onClick={() => onChange(task.id)}>{task.label}</button>)}
    </div>
    <div ref={body} className="operator-rail-body"
      onScroll={event => { positions.current[view] = event.currentTarget.scrollTop; }}>
      {TASKS.map(task => <div key={task.id} className="operator-rail-panel" role="tabpanel"
        id={`${id}-${task.id}-panel`} aria-labelledby={`${id}-${task.id}-tab`}
        hidden={view !== task.id} tabIndex={0}>{content[task.id]}</div>)}
    </div>
  </aside>;
}
